import { emojify } from 'react-emojione'

const isAbsoluteUrl = imgUrl => imgUrl.indexOf('://') > 0

const isContainingCdn = (imgUrl, attachmentCdn) => imgUrl.indexOf(attachmentCdn) !== -1

const getImageUrl = (img, width, attachmentCdn) => {
  const isAbsoluteImgUrl = isAbsoluteUrl(img)
  const isImgUrlContainingCdn = isContainingCdn(img, attachmentCdn)

  if (isAbsoluteImgUrl && !isImgUrlContainingCdn) {
    return img
  }

  if (isAbsoluteImgUrl && isImgUrlContainingCdn) {
    img = img.replace(attachmentCdn, '')
  }

  return attachmentCdn + 'width/' + width + '/' + img
}

function decodeHtmlEntities (thisIsSafeHtmlStrippedOfTagsInBackend) {
  const txt = document.createElement('textarea')
  txt.innerHTML = thisIsSafeHtmlStrippedOfTagsInBackend
  return txt.value
}

const TopicContent = ({ topic, attachmentCdn }) => {
  return topic.featuredImage
    ? (<div class='thread-list-block__article-wrapper'>
      <a class='thread-list-block__featured-image-link' href={topic.url} style={{ backgroundImage: `url(${getImageUrl(topic.featuredImage, '480', attachmentCdn)})` }} />
      <div class='thread-list-block__article-excerpt'>
        <p class={'thread-list-block__content' + (topic.featuredImage ? ' thread-list-block__content--article' : '') + ' qa-topic-content'}>
          <a href={topic.url}>
            {decodeHtmlEntities(topic.relevantPost.content)}
          </a>
        </p>
      </div>
    </div>)
    : (<p class='thread-list-block__content qa-topic-content'>
      <a href={topic.url}>
        {emojify(decodeHtmlEntities(topic.relevantPost.content), { style: { width: '16px', height: '16px', top: 0 } })}
      </a>
    </p>)
}

export default TopicContent
